import { JOB_CATEGORIES_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";
import { IPagination } from "../../shared/interfaces/shared/IPagination";
import { IJobCategory } from "../../shared/interfaces/job-category/IJobCategory";

export const JobCategoryService = {
  getAll: (params: IPagination) => requests.get(JOB_CATEGORIES_URL, params),
  getSingle: (id: number): Promise<IJobCategory> =>
    requests.get(`${JOB_CATEGORIES_URL}/${id}`),
  create: (params: IJobCategory) => requests.post(JOB_CATEGORIES_URL, params),
  update: (params: IJobCategory, id: number) =>
    requests.put(`${JOB_CATEGORIES_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${JOB_CATEGORIES_URL}/${id}`),
  sort: (ids: number[]) => requests.patch(`${JOB_CATEGORIES_URL}/sort`, { ids }),
  copy: (id: number) => requests.put(`${JOB_CATEGORIES_URL}/copy/${id}`),
};
